import { isFinite } from 'lodash/fp';
import { COLOR_TEXT } from '../../../../components/commander-ui/constants';
import { MIN_QUICK_SCROLL_HIT_TARGET_SIZE, QUICK_SCROLL_PADDING } from '../../constants';
import { CursorPosition } from '../../types';

export default function QuickScroll() {
    let show = false;
    let size = 0;
    const position = {
        x: 0,
        y: 0,
    };
    return {
        render({ ctx, canvasWidth }: $TSFixMe) {
            if (!show) {
                return;
            }

            position.x = canvasWidth - QUICK_SCROLL_PADDING;

            ctx.beginPath();
            ctx.strokeStyle = COLOR_TEXT;
            ctx.lineWidth = 4;
            ctx.lineCap = 'round';
            ctx.moveTo(position.x, position.y);
            ctx.lineTo(position.x, position.y + size);
            ctx.stroke();
        },
        collides(mousePosition: CursorPosition) {
            if (!show) {
                return false;
            }

            const padding = Math.max(MIN_QUICK_SCROLL_HIT_TARGET_SIZE - size, 0);
            return (
                mousePosition.x >= position.x - QUICK_SCROLL_PADDING &&
                mousePosition.x <= position.x + QUICK_SCROLL_PADDING &&
                mousePosition.y >= position.y - padding &&
                mousePosition.y <= position.y + size + padding
            );
        },
        resize(canvasHeight: $TSFixMe, timelineHeight: $TSFixMe, scale: $TSFixMe) {
            if (!isFinite(timelineHeight) || !isFinite(canvasHeight)) {
                return;
            }

            show = isFinite(timelineHeight) && canvasHeight < timelineHeight * scale;
            size = ((canvasHeight / timelineHeight) * canvasHeight) / scale;
        },
        move({ dy, canvasHeight }: { dy: number; canvasHeight: number }) {
            const originalY: number = position.y;

            let newY = originalY + dy;
            if (newY < QUICK_SCROLL_PADDING) {
                newY = QUICK_SCROLL_PADDING;
            }
            const bottom = canvasHeight - size - QUICK_SCROLL_PADDING;
            if (newY > canvasHeight - size - QUICK_SCROLL_PADDING) {
                newY = bottom;
            }

            position.y = newY;
            return originalY - newY;
        },
        getSize() {
            return size;
        },
        isVisible() {
            return show;
        },
    };
}
